"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REVIEW_HOME_MISSION_TITLE = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var REVIEW_HOME_MISSION_TITLE = exports.REVIEW_HOME_MISSION_TITLE = 'Your Mission';
var ReviewHomeWrapper = function ReviewHomeWrapper(Component) {
  var _class, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)((_class = /*#__PURE__*/function (_React$Component) {
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _callSuper(this, _class, [props]);
      _initializerDefineProperty(_this, "streakWasExtended", _descriptor, _this);
      _initializerDefineProperty(_this, "refreshing", _descriptor2, _this);
      _this.extendStreak = function () {
        _state.AppUI.authUserStore.addXp({
          queryStrings: {
            update_last_streak_repaired_at: false,
            update_last_streak_extended_at: true
          }
        }, _this.afterExtendStreak);
      };
      _this.afterExtendStreak = function () {
        _this.streakWasExtended = true;
        _state.AppUI.authUserDailyXpCountStore.clearIndexData();
        _state.AppUI.loadUser();
        setTimeout(function () {
          return _this.streakWasExtended = false;
        }, 10000);
      };
      _this.disableStreakExtension = function () {
        _state.AppUI.user.set('enableStreakExtension', false);
        _state.AppUI.authUserStore.update({
          data: {
            enable_streak_extension: false
          }
        }, _state.AppUI.loadUser);
      };
      _this.onRefresh = function () {
        if (_this.refreshing) {
          return;
        }
        _this.refreshing = true;
        Promise.all([new Promise(function (resolve) {
          _state.AppUI.loadUser(null, {
            forceRefresh: true,
            successCallback: resolve,
            failureCallback: resolve,
            onRequestError: resolve
          });
        }), new Promise(function (resolve) {
          _state.AppUI.loadReviewDecks(function (resp) {
            _state.AppUI.reviewDeckStore.setIndexData(resp);
            resolve();
          }, {
            failureCallback: resolve,
            onRequestError: resolve
          });
        })]).then(function () {
          return _this.refreshing = false;
        });
      };
      if (!_state.TreeUI.userTreeNodeStore.hasIndexData) {
        _state.TreeUI.userTreeNodeStore.getIndex();
      }
      return _this;
    }
    _inherits(_class, _React$Component);
    return _createClass(_class, [{
      key: "showOnboarding",
      get: function get() {
        return _state.AppUI.user.reviewCardsCount === 0;
      }
    }, {
      key: "showMissionPageOnboarding",
      get: function get() {
        return this.showOnboarding && !_state.AppUI.wasUiElementSeen('find-reviews2');
      }
    }, {
      key: "missionBodyLine1",
      get: function get() {
        var languageLabel = _state.AppUI.targetLanguageName || '';
        var deckName = languageLabel ? "".concat(languageLabel, " Reviews") : 'Reviews';
        return "Find new words and sentences and add them to your \"".concat(deckName, "\" deck.");
      }
    }, {
      key: "missionBodyLine2",
      get: function get() {
        var sections = _state.AppUI.targetLanguageId === 'DE' ? 'Stories, Vocab, and Trivia sections' : 'Stories and Vocab sections';
        return "Explore our ".concat(sections, ".");
      }
    }, {
      key: "showFirstTimeStreakExtendBanner",
      get: function get() {
        var _AppUI$user$lastStrea;
        return _state.AppUI.userIsLoaded && _state.AppUI.user.enableStreakExtension && _state.AppUI.user.currentDayXp >= _state.AppUI.user.streakExtendGoal && (0, _utils.isBlank)((_AppUI$user$lastStrea = _state.AppUI.user.lastStreakExtendedAt) === null || _AppUI$user$lastStrea === void 0 ? void 0 : _AppUI$user$lastStrea.date);
      }
    }, {
      key: "tabs",
      get: function get() {
        return [{
          name: 'reviewDecks',
          label: 'Reviews',
          "default": true,
          icon: 'Reviews'
        }, {
          name: 'reviewIndex',
          label: 'Manage',
          icon: 'List'
        }, {
          name: 'reviewsCreate',
          label: 'Create',
          icon: 'Plus'
        }, {
          name: 'reviewArchive',
          label: 'Archive',
          icon: 'ArrowDown'
        }];
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showOnboarding: this.showOnboarding,
          showMissionPageOnboarding: this.showMissionPageOnboarding,
          missionTitle: REVIEW_HOME_MISSION_TITLE,
          missionBodyLine1: this.missionBodyLine1,
          missionBodyLine2: this.missionBodyLine2,
          tabs: this.tabs,
          showFirstTimeStreakExtendBanner: this.showFirstTimeStreakExtendBanner,
          extendStreak: this.extendStreak,
          disableStreakExtension: this.disableStreakExtension,
          streakWasExtended: this.streakWasExtended,
          refreshing: this.refreshing,
          onRefresh: this.onRefresh
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class.prototype, "streakWasExtended", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "refreshing", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "showOnboarding", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showOnboarding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showMissionPageOnboarding", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showMissionPageOnboarding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "missionBodyLine1", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "missionBodyLine1"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "missionBodyLine2", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "missionBodyLine2"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showFirstTimeStreakExtendBanner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showFirstTimeStreakExtendBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tabs"), _class.prototype), _class));
};
ReviewHomeWrapper.displayName = 'ReviewHomeWrapper';
var _default = exports["default"] = ReviewHomeWrapper;